import {computedFrom, transient} from "aurelia-framework";
import {BaseRuleConfigPlugin} from "./base-rule-config-plugin";
import { Reflection } from "../../../../../../../utilities/reflection";

@transient()
export class RequirePscReview extends BaseRuleConfigPlugin {

    itemSource: { name: string; id: number; mapping: string; }[] = [
        {name: "days", id: 1, mapping: "today"},
        {name: "weeks", id: 1, mapping: "week"},
        {name: "months", id: 2, mapping: "month"},
        {name: "years", id: 3, mapping: "year"}
    ];


    andOrItemSource: { name: string; value: boolean; }[] = [
        {name: "and", value: true},
        {name: "or", value: false}
    ];

    operators: {
        friendlyName: string;
        translatedSymbol: string;
        requiresInterpolation: boolean;
        isOnlyForNullableProperties: boolean;
        requiresFilterValue: boolean;
    }[] = [
        {
            friendlyName: "=",
            translatedSymbol: "eq",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        },
        {
            friendlyName: "<>",
            translatedSymbol: "ne",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        },
        {
            friendlyName: "<",
            translatedSymbol: "lt",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        },
        {
            friendlyName: "<=",
            translatedSymbol: "le",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        },
        {
            friendlyName: ">",
            translatedSymbol: "gt",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        },
        {
            friendlyName: ">=",
            translatedSymbol: "ge",
            requiresInterpolation: false,
            isOnlyForNullableProperties: false,
            requiresFilterValue: true
        }];

        @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.meta.date))
    get date() {
        if (this.meta.date) {
            const s = this.meta.date.split(" - ");
            return s.length > 1 ? s[1] : "";
        }

        return "";
    }

    @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.meta.dateDetentions),
    Reflection.getPropertyPath<RequirePscReview>(z => z.meta.dateDetentions.length))
    get dateDetentions() {
        if (this.meta.dateDetentions) {
            const s = this.meta.dateDetentions.split(" - ");
            return s.length > 1 ? s[1] : "";
        }

        return "";
    }

    @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.meta.date))
    get day() {
        if (this.meta.date) {
            const s = this.meta.date.split(" - ");
            return s.length > 0 ? s[0] : null;
        }

        return null;
    }
 
    @computedFrom(Reflection.getPropertyPath<RequirePscReview>(z => z.meta.dateDetentions),
    Reflection.getPropertyPath<RequirePscReview>(z => z.meta.dateDetentions.length))
    get dayDetentions() {
        if (this.meta.dateDetentions) {
            const s = this.meta.dateDetentions.split(" - ");
            return s.length > 0 ? s[0] : null;
        }

        return null;
    }

    set day(x: string) {
        this.meta.date = this.date ? `${x} - ${this.date}` : x;
    }

    set dayDetentions(x: string) {
        this.meta.dateDetentions = this.dateDetentions ? `${x} - ${this.dateDetentions}` : x;
    }

    set date(x: string) {
        if (this.day) {
            this.meta.date = `${this.day} - ${x}`;
        }
    }

    set dateDetentions(x: string) {
        if (this.dayDetentions) {
            this.meta.dateDetentions = `${this.dayDetentions} - ${x}`;
        }
    }

    attached() {
        if (this.meta.filterByDeficiencies == null || this.meta.filterByDeficiencies == undefined)
            this.meta.filterByDeficiencies = true;
        if (this.meta.filterByDetentions == null || this.meta.filterByDetentions == undefined)
            this.meta.filterByDetentions = true;
    }
}